import { RootState, INITIAL_STATE, ConflictResolution, HunkDecision } from "../core/state-shape";
import { http } from "../lib/http";
import { createProjectScopedStore } from './projectScoped';

import { measure } from '@/lib/performance';

export type ConflictsState = RootState["review"];

type ConflictsActions = {
  setState: (newState: ConflictsState) => void;
  patch: (p: Partial<ConflictsState>) => void;
  reset: () => void;
  load: (sessionId: string) => Promise<void>;
  resolve: (sessionId: string, decisions: Record<string, any>) => Promise<void>;
  resolveHunk: (hunkId: string, choice: ConflictResolution, manualText?: string) => void;
};

export const useConflictsStore = createProjectScopedStore<ConflictsState & ConflictsActions>('conflicts', (set, get) => ({
  ...INITIAL_STATE.review,
  setState: (newState) => set(newState),
  patch: (p) => set(p),
  reset: () => set({ ...INITIAL_STATE.review }),

  load: measure(async (sessionId) => {
    const res = await http<any>(`/api/conflicts/${encodeURIComponent(sessionId)}`);
    set({ conflicts: res });
  }, 'conflicts.load'),

  resolve: measure(async (sessionId, decisions) => {
    await http<{ success: true; resolved: number }>(
      `/api/conflicts/${encodeURIComponent(sessionId)}/resolve`,
      {
        method: "POST",
        body: JSON.stringify({ decisions }),
      }
    );
  }, 'conflicts.resolve'),
  resolveHunk: (hunkId, choice, manualText) => {
    const { conflicts } = get();
    if (!conflicts) return;
    
    const newDecision: HunkDecision = {
      hunkId,
      choice,
      ts: new Date().toISOString(),
    };

    if (choice === 'manual') {
        newDecision.manualText = manualText;
    }

    set({
      conflicts: {
        ...conflicts,
        decisions: {
          ...conflicts.decisions,
          [hunkId]: newDecision,
        },
      },
    });
  },
}));